import { Navigate } from "react-router-dom"
import { useLaunchPath } from "~/hooks/useLaunchPath"
import { LoadingState } from "~/components/screens/StateScreen"

import { Link } from "~/components/Link"
import { OrbitLogo } from "~/components/icons/logos"
import { OrgSwitcher } from "~/components/OrgSwitcher"
import { FullScreen } from "~/components/screens/FullScreen"
import { Badge } from "~/components/ui/badge"
import { Button } from "~/components/ui/button"
import { authClient } from "~/lib/auth-client"

export function LandingPage() {
	const { data: session, isPending: isSessionPending } = authClient.useSession()
	const {
		data: orgs,
		isPending: isOrgsPending,
		error
	} = authClient.useListOrganizations()

	const launch = useLaunchPath(session?.user.id)
	if (
		isSessionPending ||
		(session && (launch.isLoading || (!launch.path && isOrgsPending)))
	) {
		return <LoadingState scope="page" branded />
	}

	if (session) {
		if (launch.path) return <Navigate to={launch.path} replace />

		if (error) {
			return (
				<FullScreen
					title="Error"
					message="Failed to load organizations. Please try again later."
				/>
			)
		}

		return (
			<div className="w-screen h-screen flex flex-col gap-6 items-center justify-center bg-orbit-gradient">
				<header className="flex flex-col gap-2 items-center justify-center">
					<OrbitLogo fill="var(--color-text-main)" />
					<h1 className="text-text-main text-xl">Select an organization</h1>
				</header>
				<OrgSwitcher
					orgs={orgs ?? []}
					withUserInfo
					withCreate
					className="w-96 h-min bg-transparent border-stroke border rounded-lg"
				/>
			</div>
		)
	}

	return (
		<FullScreen
			title=""
			message="Welcome to Orbit."
			centerContent={<Badge>Alpha</Badge>}
			bottomContent={
				<Link to="/login">
					<Button variant="outline">Login to Orbit</Button>
				</Link>
			}
		/>
	)
}
